/**
 * `window.__ttfe` — browser-console dev commands for testing the Faster TTFE
 * pending window. Each module registers its own commands; they merge into one
 * namespace. Never installed under tests.
 */
declare global {
  interface Window {
    __ttfe?: Record<string, unknown>;
  }
}

export function registerTtfeConsoleCommands(
  commands: Record<string, (...args: never[]) => unknown>,
): void {
  const isTest =
    typeof process !== 'undefined' && process.env.NODE_ENV === 'test';
  if (typeof window === 'undefined' || isTest) return;
  window.__ttfe = { ...window.__ttfe, ...commands };
}
